module.exports = __webpack_public_path__ + "img/Chart.8ca557d9.png";